import _reject from "ramda/es/reject";
import isNilOrEmpty from './isNilOrEmpty';
export default _reject(isNilOrEmpty);